import { render } from "./footerBanner.vue?vue&type=template&id=3250c7e4&scoped=true"
import script from "./footerBanner.vue?vue&type=script&lang=js"
export * from "./footerBanner.vue?vue&type=script&lang=js"

import "./footerBanner.vue?vue&type=style&index=0&id=3250c7e4&scoped=true&lang=css"
import "./footerBanner.vue?vue&type=style&index=1&id=3250c7e4&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3250c7e4"]])

export default __exports__